interface IconProps {
  className?: string
}

// Marketplace icon — shopping bag with tag motif
// Brand colours: Green #48c37e, Dark #242c29
export function MarketplaceIcon({ className = 'w-10 h-10' }: IconProps) {
  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      {/* Bag body */}
      <rect x="8" y="18" width="32" height="24" rx="3" fill="#48c37e" />
      {/* Bag handles */}
      <path d="M16 18V14C16 9.58 19.58 6 24 6C28.42 6 32 9.58 32 14V18" stroke="#242c29" strokeWidth="2.5" strokeLinecap="round" fill="none" />
      {/* Price tag */}
      <circle cx="24" cy="28" r="4" fill="white" opacity="0.9" />
      <path d="M22 28L24 30L26 28" stroke="#242c29" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

// Automotive icon — car silhouette
// Brand colours: Green #48c37e, Dark #242c29
export function AutomotiveIcon({ className = 'w-10 h-10' }: IconProps) {
  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      {/* Car body */}
      <path d="M6 28L10 18H16L22 12H34L38 18H42L42 28H40V32H34V28H14V32H8V28H6Z" fill="#48c37e" />
      {/* Windshield */}
      <path d="M22 14L18 18H14L18 14H22Z" fill="#242c29" opacity="0.3" />
      <path d="M24 14H32L36 18H20L24 14Z" fill="#242c29" opacity="0.3" />
      {/* Wheels */}
      <circle cx="14" cy="30" r="4" fill="#242c29" />
      <circle cx="14" cy="30" r="1.5" fill="white" />
      <circle cx="34" cy="30" r="4" fill="#242c29" />
      <circle cx="34" cy="30" r="1.5" fill="white" />
      {/* Road line */}
      <line x1="4" y1="36" x2="44" y2="36" stroke="#242c29" strokeWidth="1" opacity="0.2" />
    </svg>
  )
}

// Fundraiser icon — heart with hands/community motif
// Brand colours: Green #48c37e, Dark #242c29, Orange #FF6B00
export function FundraiserIcon({ className = 'w-10 h-10' }: IconProps) {
  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      {/* Heart */}
      <path d="M24 40L8 26C4 22 4 16 8 12C12 8 18 8 22 12L24 14L26 12C30 8 36 8 40 12C44 16 44 22 40 26L24 40Z" fill="#48c37e" />
      {/* Inner heart highlight */}
      <path d="M24 34L12 24C10 22 10 18 12 16C14 14 18 14 20 16L24 20L28 16C30 14 34 14 36 16C38 18 38 22 36 24L24 34Z" fill="white" opacity="0.3" />
      {/* Star accent */}
      <path d="M24 20L25.5 23L29 23.5L26.5 26L27 29.5L24 28L21 29.5L21.5 26L19 23.5L22.5 23L24 20Z" fill="#FF6B00" />
    </svg>
  )
}

// Mapping function: group icon key -> React component
const ICON_MAP: Record<string, React.ComponentType<IconProps>> = {
  marketplace: MarketplaceIcon,
  automotive: AutomotiveIcon,
  fundraiser: FundraiserIcon,
}

// Render a category group icon by its key string
export function CategoryGroupIcon({ iconKey, className }: { iconKey: string; className?: string }) {
  const Icon = ICON_MAP[iconKey]
  if (!Icon) return null
  return <Icon className={className} />
}
